import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './locales/en.json';
import translationES from './locales/es.json';
import translationsFR from "./locales/fr.json";
import {useSelector} from "react-redux";

i18n
    .use(initReactI18next)
    .init({
        resources: {
            English: { translation: translationEN },
            Español: { translation: translationES },
            Français: { translation: translationsFR }
        },
        lng: localStorage.getItem("currentLanguage") || "English", // default language is set to local storage to persist refresh
        fallbackLng: 'English',
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
